<template>
    <div
        class="annual-fee-container w-full grid grid-cols-12 gap-1 text-left md:flex md:flex-col md:text-center xl:justify-start 2xl:justify-center xl:mx-3"
    >
        <span
            class="text-xs font-semibold xl:hidden w-full md:w-auto col-span-5 md:col-span-12 whitespace-nowrap"
        >
            Annual Fee:
        </span>
        <div
            class="flex flex-col w-full md:w-auto md:text-center col-span-7 md:col-span-12"
            v-if="!item.user_managed_annual_fee"
        >
            <span
                class="text-xs inline-block"
                v-if="
                    item.card &&
                    item.card.initial_annual_fee &&
                    item.initial_annual_fee_active
                "
            >
                <span class="text-red-400 text-sm line-through md:block">
                    <span
                        class="text-gray-500 text-xs lg:text-sm ml-2 xl:ml-0"
                        :class="{
                            'text-gray-400 line-through':
                                item.card_status === 'closed',
                        }"
                    >
                        ${{ item.card.annual_fee }}
                    </span>
                </span>
                <span class="ml-2 md:block md:ml-0">
                    <span
                        class="text-xs lg:text-sm font-semibold"
                        :class="{
                            'text-gray-400 line-through':
                                item.card_status === 'closed',
                        }"
                    >
                        ${{ item.card.initial_annual_fee }}
                    </span>
                    <span class="hidden md:block">
                        for your first year, then
                        <span class="text-xs lg:text-sm">
                            ${{ item.card.annual_fee }}
                        </span>
                    </span>
                </span>
            </span>
            <span
                class="ml-2 sm:ml-0 text-xs lg:text-sm"
                :class="{
                    'text-gray-400 line-through': item.card_status === 'closed',
                }"
                v-if="
                    item.card &&
                    item.card.annual_fee &&
                    !item.initial_annual_fee_active
                "
            >
                ${{ item.card.annual_fee }}
            </span>
            <span
                v-if="
                    item.card &&
                    item.date_opened &&
                    item.annual_fee_due_date &&
                    item.annual_fee_due_date.within_sixty_days &&
                    item.card.annual_fee > 0 &&
                    item.card_status === 'open'
                "
            >
                <span class="text-xs hidden lg:block">
                    (Due: {{ item.annual_fee_due_date.date }})

                    <span
                        class="inline-block rounded-full text-gray-400 text-center relative annual-fee-label-trigger cursor-pointer ml-1"
                        v-if="
                            item.card &&
                            item.date_opened &&
                            item.card.annual_fee > 0 &&
                            item.annual_fee_due_date &&
                            item.annual_fee_due_date.within_sixty_days
                        "
                    >
                        <span class="annual-fee-label text-xs">
                            This is an estimate for your planning purposes.
                            Consult with your issuer for the exact date.
                        </span>
                        <i class="fa-regular fa-circle-exclamation"></i>
                    </span>
                </span>
            </span>
        </div>
        <div v-if="item.user_managed_annual_fee">
            <span class="text-red-400 text-sm md:block">
                <span
                    class="text-gray-500 text-xs lg:text-sm"
                    :class="{
                        'text-gray-400 line-through':
                            item.card_status === 'closed',
                    }"
                >
                    ${{ item.annual_fee }}
                </span>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
        },
    },
};
</script>
<style lang="scss" scoped>
.annual-fee-label-trigger {
    &:hover {
        .annual-fee-label {
            display: block;
        }
    }
}
.annual-fee-label {
    display: none;
    width: 200px;
    padding: 6px 12px;
    color: #fff;
    background-color: #1c293d;
    border-radius: 4px;
    position: absolute;
    bottom: 110%;
    left: 50%;
    margin-left: -100px;
}
</style>
